import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigationType } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import Index from "./pages/Index";


// Lazy load all non-critical routes to reduce initial JS bundle
const NotFound = lazy(() => import("./pages/NotFound"));
const PrivacyPolicyPage = lazy(() => import("./pages/LegalPages").then(m => ({ default: m.PrivacyPolicyPage })));
const CookiePolicyPage = lazy(() => import("./pages/LegalPages").then(m => ({ default: m.CookiePolicyPage })));
const LegalNoticePage = lazy(() => import("./pages/LegalPages").then(m => ({ default: m.LegalNoticePage })));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const UberLyftSR22 = lazy(() => import("./pages/articles/UberLyftSR22"));
const NonOwnerSR22 = lazy(() => import("./pages/articles/NonOwnerSR22"));
const SR22DUI = lazy(() => import("./pages/articles/SR22DUI"));
const SR22Barato = lazy(() => import("./pages/articles/SR22Barato"));
const SR22Instantaneo = lazy(() => import("./pages/articles/SR22Instantaneo"));
const SR22MudanzaEstado = lazy(() => import("./pages/articles/SR22MudanzaEstado"));
const SR22Moto = lazy(() => import("./pages/articles/SR22Moto"));
const SR22SinCredito = lazy(() => import("./pages/articles/SR22SinCredito"));
const CancelarSR22 = lazy(() => import("./pages/articles/CancelarSR22"));
const SR22vsFR44 = lazy(() => import("./pages/articles/SR22vsFR44"));
const SR22Florida = lazy(() => import("./pages/articles/SR22Florida"));
const SR22California = lazy(() => import("./pages/articles/SR22California"));
const SR22Texas = lazy(() => import("./pages/articles/SR22Texas"));
const SR22Illinois = lazy(() => import("./pages/articles/SR22Illinois"));
const SR22Arizona = lazy(() => import("./pages/articles/SR22Arizona"));
const CuantoDuraSR22 = lazy(() => import("./pages/articles/CuantoDuraSR22"));
const VerificarLicenciaSR22 = lazy(() => import("./pages/articles/VerificarLicenciaSR22"));
const FormularioSR26 = lazy(() => import("./pages/articles/FormularioSR26"));
const SR22LicenciaCDL = lazy(() => import("./pages/articles/SR22LicenciaCDL"));
const SR22MudanzaInterestatal = lazy(() => import("./pages/articles/SR22MudanzaInterestatal"));
const ResenaTheGeneral = lazy(() => import("./pages/articles/ResenaTheGeneral"));
const ResenaDairyland = lazy(() => import("./pages/articles/ResenaDairyland"));
const ResenaKemper = lazy(() => import("./pages/articles/ResenaKemper"));
const ComparativaFinalSR22 = lazy(() => import("./pages/articles/ComparativaFinalSR22"));
const SR22ConITIN = lazy(() => import("./pages/articles/SR22ConITIN"));
const SR22LicenciaExtranjera = lazy(() => import("./pages/articles/SR22LicenciaExtranjera"));
const QueEsSR22 = lazy(() => import("./pages/articles/QueEsSR22"));
const AccidenteSinSeguro = lazy(() => import("./pages/articles/AccidenteSinSeguro"));
const LicenciaChildSupport = lazy(() => import("./pages/articles/LicenciaChildSupport"));
const GuiaIID = lazy(() => import("./pages/articles/GuiaIID"));
const CostoDUI = lazy(() => import("./pages/articles/CostoDUI"));
const ProgressiveVsDairyland = lazy(() => import("./pages/articles/ProgressiveVsDairyland"));
const RemoverSR22 = lazy(() => import("./pages/articles/RemoverSR22"));
const LimpiarAntecedentes = lazy(() => import("./pages/articles/LimpiarAntecedentes"));
const AffidavitMasterFile = lazy(() => import("./pages/articles/AffidavitMasterFile"));
const TrampaNonOwner = lazy(() => import("./pages/articles/TrampaNonOwner"));
const SR22EstadoAnterior = lazy(() => import("./pages/articles/SR22EstadoAnterior"));
const SR22Trabajo = lazy(() => import("./pages/articles/SR22Trabajo"));
const SR22Nevada = lazy(() => import("./pages/articles/SR22Nevada"));
const SR22Colorado = lazy(() => import("./pages/articles/SR22Colorado"));
const SR22Georgia = lazy(() => import("./pages/articles/SR22Georgia"));
const SR22NewJersey = lazy(() => import("./pages/articles/SR22NewJersey"));
const SR22NewYork = lazy(() => import("./pages/articles/SR22NewYork"));
const VerificarLicenciaSuspendida = lazy(() => import("./pages/articles/VerificarLicenciaSuspendida"));
const AseguranzaSinLicencia = lazy(() => import("./pages/articles/AseguranzaSinLicencia"));
const SR22Washington = lazy(() => import("./pages/articles/SR22Washington"));
const SR22NorthCarolina = lazy(() => import("./pages/articles/SR22NorthCarolina"));
const SR22Connecticut = lazy(() => import("./pages/articles/SR22Connecticut"));
const SR22Oregon = lazy(() => import("./pages/articles/SR22Oregon"));
const SR22Maryland = lazy(() => import("./pages/articles/SR22Maryland"));
const SR22Indiana = lazy(() => import("./pages/articles/SR22Indiana"));
const SR22Massachusetts = lazy(() => import("./pages/articles/SR22Massachusetts"));
const SR22Pennsylvania = lazy(() => import("./pages/articles/SR22Pennsylvania"));
const SR22Wisconsin = lazy(() => import("./pages/articles/SR22Wisconsin"));
const SR22Virginia = lazy(() => import("./pages/articles/SR22Virginia"));
const SR22SinSeguroSocial = lazy(() => import("./pages/articles/SR22SinSeguroSocial"));
const CalculadoraSR22 = lazy(() => import("./pages/CalculadoraSR22"));

function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, navType]);
  return null;
}

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
        
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/sobre-nosotros" element={<AboutPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/politica-de-privacidad" element={<PrivacyPolicyPage />} />
            <Route path="/politica-de-cookies" element={<CookiePolicyPage />} />
            <Route path="/aviso-legal" element={<LegalNoticePage />} />
            {/* Artículos originales */}
            <Route path="/sr22-uber-lyft-doordash" element={<UberLyftSR22 />} />
            <Route path="/seguro-sr22-non-owner" element={<NonOwnerSR22 />} />
            <Route path="/sr22-despues-de-dui" element={<SR22DUI />} />
            <Route path="/seguro-sr22-barato-por-estado" element={<SR22Barato />} />
            <Route path="/sr22-electronico-instantaneo" element={<SR22Instantaneo />} />
            <Route path="/sr22-mudanza-otro-estado" element={<SR22MudanzaEstado />} />
            <Route path="/sr22-para-motos" element={<SR22Moto />} />
            <Route path="/sr22-sin-credito-sin-down-payment" element={<SR22SinCredito />} />
            <Route path="/cancelar-sr22" element={<CancelarSR22 />} />
            <Route path="/sr22-vs-fr44" element={<SR22vsFR44 />} />
            {/* Geo */}
            <Route path="/sr22-florida" element={<SR22Florida />} />
            <Route path="/sr22-california" element={<SR22California />} />
            <Route path="/sr22-texas" element={<SR22Texas />} />
            <Route path="/sr22-illinois" element={<SR22Illinois />} />
            <Route path="/sr22-arizona" element={<SR22Arizona />} />
            {/* Técnicos */}
            <Route path="/cuanto-dura-sr22" element={<CuantoDuraSR22 />} />
            <Route path="/verificar-licencia-sr22" element={<VerificarLicenciaSR22 />} />
            <Route path="/formulario-sr26" element={<FormularioSR26 />} />
            <Route path="/sr22-licencia-cdl" element={<SR22LicenciaCDL />} />
            <Route path="/sr22-mudanza-interestatal" element={<SR22MudanzaInterestatal />} />
            {/* Reseñas */}
            <Route path="/resena-the-general" element={<ResenaTheGeneral />} />
            <Route path="/resena-dairyland" element={<ResenaDairyland />} />
            <Route path="/resena-kemper" element={<ResenaKemper />} />
            <Route path="/comparativa-sr22" element={<ComparativaFinalSR22 />} />
            {/* Nuevos artículos */}
            <Route path="/sr22-con-itin" element={<SR22ConITIN />} />
            <Route path="/sr22-licencia-extranjera" element={<SR22LicenciaExtranjera />} />
            <Route path="/que-es-sr22" element={<QueEsSR22 />} />
            <Route path="/accidente-sin-seguro" element={<AccidenteSinSeguro />} />
            <Route path="/licencia-suspendida-child-support" element={<LicenciaChildSupport />} />
            <Route path="/guia-iid-alcoholimetro" element={<GuiaIID />} />
            <Route path="/costo-seguro-despues-dui" element={<CostoDUI />} />
            <Route path="/progressive-vs-dairyland" element={<ProgressiveVsDairyland />} />
            <Route path="/remover-sr22" element={<RemoverSR22 />} />
            <Route path="/limpiar-antecedentes-dui" element={<LimpiarAntecedentes />} />
            <Route path="/affidavit-master-file-florida" element={<AffidavitMasterFile />} />
            <Route path="/trampa-seguro-non-owner-roommate" element={<TrampaNonOwner />} />
            <Route path="/sr22-cumplir-estado-anterior" element={<SR22EstadoAnterior />} />
            <Route path="/sr22-trabajo-empleador" element={<SR22Trabajo />} />
            <Route path="/sr22-nevada" element={<SR22Nevada />} />
            <Route path="/sr22-colorado" element={<SR22Colorado />} />
            <Route path="/sr22-georgia" element={<SR22Georgia />} />
            <Route path="/sr22-new-jersey" element={<SR22NewJersey />} />
            <Route path="/sr22-new-york" element={<SR22NewYork />} />
            <Route path="/como-verificar-licencia-suspendida" element={<VerificarLicenciaSuspendida />} />
            <Route path="/aseguranza-full-cover-sin-licencia" element={<AseguranzaSinLicencia />} />
            <Route path="/sr22-washington" element={<SR22Washington />} />
            <Route path="/sr22-north-carolina" element={<SR22NorthCarolina />} />
            <Route path="/sr22-connecticut" element={<SR22Connecticut />} />
            <Route path="/sr22-oregon" element={<SR22Oregon />} />
            <Route path="/sr22-maryland" element={<SR22Maryland />} />
            <Route path="/sr22-indiana" element={<SR22Indiana />} />
            <Route path="/sr22-massachusetts" element={<SR22Massachusetts />} />
            <Route path="/sr22-pennsylvania" element={<SR22Pennsylvania />} />
            <Route path="/sr22-wisconsin" element={<SR22Wisconsin />} />
            <Route path="/sr22-virginia" element={<SR22Virginia />} />
            <Route path="/sr22-sin-seguro-social-itin" element={<SR22SinSeguroSocial />} />
            <Route path="/calculadora-sr22" element={<CalculadoraSR22 />} />
            {/* Redirects for common alternate URLs */}
            <Route path="/guia-sr-22" element={<Navigate to="/#guia" replace />} />
            <Route path="/guia-sr-22/" element={<Navigate to="/#guia" replace />} />
            <Route path="/sr-22-sin-vehiculo-no-propietario" element={<Navigate to="/seguro-sr22-non-owner" replace />} />
            <Route path="/sr-22-sin-vehiculo-no-propietario/" element={<Navigate to="/seguro-sr22-non-owner" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
      </Suspense>
  </BrowserRouter>
);

export default App;
